import lf from 'lovefield'

export function exo_chantiers (schemaBuilder) {
  schemaBuilder.createTable('exo_chantiers')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('kmdebut')
      .addColumn('longueur')
      .addColumn('const_humidite_id')
      .addColumn('efficience')
      .addColumn('debut')
      .addColumn('delai')
      .addColumn('budget')
      .addColumn('vitessemax')
      .addColumn('stopautomatiqsimu_1')
      .addColumn('stopautomatiqsimu_2')
      .addColumn('description')
      .addColumn('alea_group_id', lf.Type.INTEGER)
      .addNullable(['alea_group_id'])
      .addPrimaryKey(['id'])
}

/*
CREATE TABLE exo-chantiers (
  id int(11) NOT NULL,
  code varchar(6) NOT NULL,
  nom varchar(80) NOT NULL,
  longueur int(11) NOT NULL COMMENT 'en mètres',
  const-humidites_code varchar(10) NOT NULL,
  efficience tinyint(4) NOT NULL COMMENT 'en pourcentage',
  delai int(11) NOT NULL COMMENT 'en jours',
  budget int(11) NOT NULL COMMENT 'en euros',
  vitessemax int(11) NOT NULL COMMENT 'en km/h',
  stopautomatiqsimu-1 tinyint(4) NOT NULL DEFAULT '50',
  stopautomatiqsimu-2 tinyint(4) NOT NULL DEFAULT '0',
  description text NOT NULL
) ENGINE=InnoDB DEFAULT CHARSET=utf8

*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/exoChantiers.schema.js